import { Container, Spacer } from '@loomhq/lens';
import classNames from 'classnames';
import $ from 'jquery';
import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';

import { showConfirmationModal } from 'actions/confirmationModal';
import { showErrorBar } from 'actions/errorBar';
import { updateLoginOrSignUp } from 'actions/login';
import { openModal } from 'actions/modals';
import { updateNotificationSettings } from 'actions/notification-settings';
import {
  updateShareVideo,
  updateShareVideoInTrimMode,
  updateShareVideoPassword,
  updateShareVideoShowRemoveModal,
  updateVideoCtaShow,
  updateVideoIframeVisibility,
} from 'actions/shareVideo';
import { showStatusBar } from 'actions/statusBar';
import { requestVideoPlayerCurrentTime } from 'actions/videoPlayer';
import { toggleViewerInsightsUI } from 'actions/viewerInsights';
import {
  LARGE_TABLET_MAX_WIDTH,
  SMALL_DESKTOP_MIN_WIDTH,
  SMALL_TABLET_MAX_WIDTH,
  TABLET_MIN_WIDTH,
} from 'constants/breakpoints';
import { INFO } from 'constants/error-severities';
import {
  ENTERED_TRIM_MODE,
  NEW_ONBOARDING_EXISTING_USER_COMPLETE,
  PUSH_NOTIFICATION_PROMPT_DISMISSED,
} from 'constants/events';
import { VIDEO_DURATION } from 'constants/limits';
import {
  EMBED_DIMENSIONS_UPDATE,
  EMBED_VIDEO_CORRECT_PASS,
  EMBED_VIDEO_DURATION,
  EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED,
  EXTENSION_CLICKED,
} from 'constants/messages';
import {
  ANON_CREATOR_CLAIM_MODAL,
  ANON_CREATOR_SIGNUP_MODAL,
  SHARE_RECORD_REPLY_SIGNUP_MODAL,
} from 'constants/modalTypes';
import { V4 } from 'constants/recordingVersions';
import { LOOM_URI, ROOT_PAGE, WELCOME } from 'constants/routes';
import {
  AUTHENTICATED_USER_ACCESS,
  RECORDING_TIMER_PAYWALL,
  RECORDING_TIMER_PAYWALL_LITE,
  SUGGESTED_WORKSPACE_BANNER,
  VIDEO_EDIT_OPTIONS_ACCESS,
  VIDEO_TOOLS_ACCESS,
  WATCH_LATER,
} from 'constants/scopes';
import {
  NEW_ONBOARDING_EXISTING_USER,
  REQUEST_PUSH_PERMISSIONS,
  SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE,
} from 'constants/triggers';
import { getFeatureFlagCreator } from 'creators/featureFlag';
import {
  fetchAnonCreatorMode,
  fetchShareVideoDownloadUrlCreator,
  handleToggleTranscriptCreator,
  subscribeToGif,
  updateVideoNameCreator,
} from 'creators/shareVideo';
import {
  activateTriggerCreator,
  completeTriggerCreator,
} from 'creators/triggers';
import { enterTrimModeCreator } from 'creators/trimming';
import { postVerifyEmail } from 'creators/user';
import { sendInactiveVideoOwnerPing } from 'creators/videoPlayer';
import { hasScope, hasSomeScopes } from 'selectors/scopes';
import { selectDrawSharepageControlBar } from 'selectors/shareVideo';
import { selectIsActive as viewerInsightsActive } from 'selectors/viewerInsights';
import * as analytics from 'utilities/analytics';
import { getCloudfrontURI } from 'utilities/avatar';
import * as clipboard from 'utilities/clipboard';
import * as device from 'utilities/device';
import * as extension from 'utilities/extension';
import { getFlagValueForUser } from 'utilities/featureFlag';
import * as jqueryExt from 'utilities/jqueryExt';
import { getParam, goToNewTab, hasParam } from 'utilities/url';

import { useFeatureFlagValue } from 'hooks/featureFlag';
import { DestinationOnly } from 'hooks/useDestination';
import { useMatchMobileOnly } from 'hooks/useMatchMedia';
import { useRoleLimit } from 'hooks/useRoleLimit';
import { useWorkspaceLimit } from 'hooks/useWorkspaceLimit';

import AnonEditVideoButtonsComponent from './anon-edit-video-buttons';
import AttachmentUploadProgressModal from './attachment-upload-progress-modal';
import AttachmentsBar from './attachments-bar';
import Banners from './banners';
import Comments from './comments';
import ContentLimitPaywallModal from './content-limit-paywall-modal';
import ShareVideoControlBar from './control-bar';
import CustomCtaButton from './cta-button';
import CtaModal from './cta-modal';
import DestinationBreadcrumb from './destination-breadcrumb';
import EditTools from './edit-tools';
import OldEditTools from './edit-tools-old';
import OldTrimExitWarningModal from './edit-tools-old/exit-warning-modal';
import TrimExitWarningModal from './edit-tools/exit-warning-modal';
import EditVideoButtonsComponent from './edit-video-buttons';
import EditorWidget from './editor-widget';
import EngagementBar from './engagement-bar';
import SharePageHeaderContent from './header-content';
import JoinTeamBanner from './join-team-banner';
import MobileAppCard from './mobile-app-card';
import MoveModal from './move-modal';
import OverflowMenu from './overflow-menu';
import ProcessErrorModal from './process-error-modal';
import RecordingTimerPaywallModal from './recording-timer-paywall';
import RightPanel from './right-panel';
import TagsTypeahead from './tags-section';
import ThumbnailCropper from './thumbnail-cropper';
import Transcript from './transcript';
import TranscriptIconButton from './transcript/transcript-icon-button';
import TrimFooter from './trim-footer';
import VideoDescription from './video-description';
import VideoRemoveModal from './video-remove-modal';
import VideoReplyParentIndicator from './video-reply-parent-indicator';
import ViewerVideoButtonsComponent from './viewer-video-buttons';
import WatchLaterButton from './watch-later-button';
import { OverlayWrapper } from './edit-tools-old/overlay-wrapper';
import {
  NewWaveformWrapper,
  OldWaveformWrapper,
} from './edit-tools-old/waveform-flag-wrapper';
import { BOTTOM_CARD_HEIGHT } from './transcript/constants';
import {
  getCustomBrandLogo,
  getLoomBrandVisibility,
} from '../../utilities/custom-branding';
import { isSdkSupported as importedIsSdkSupported } from '../../utilities/sdk-support/isSdkSupported';
import { TEAM_ACCOUNT_TYPES } from '../../../../shared/constants/accountTypes';
import { END_OF_VIDEO_CTA } from '../../../../shared/constants/capabilities';
import {
  EXP_ANON_SWIMLANES_AA,
  EXP_GOOGLE_ONE_TAP_SHARE_PAGE,
  EXP_PERSISTENT_RECORD_BUTTON_SIGNED_OUT,
  EXP_SWIMLANES_AA,
  inactiveDefaultVariations,
  ROLLOUT_FILE_ATTACHMENTS,
  ROLLOUT_INTEGRATIONS_LISTING,
  ROLLOUT_WEAVE,
  SHOW_MOBILE_APP_CARD,
  STORE_FILLER_WORD_RANGES,
  VARIANT,
} from '../../../../shared/constants/featureFlag';
import {
  FAILED,
  TRANSCRIPTION_STATUSES,
} from '../../../../shared/constants/videoTranscript';

import ConfirmationModal from 'components/confirmation-modal';
import FeatureFlaggedComponent from 'components/feature-flag-wrapper';
import GoogleOneTap from 'components/google-one-tap';
import Layout from 'components/layout';
import LoomBadge from 'components/loom-badge';
import MediaQuery from 'components/media-query';
import OwnerInfo from 'components/owner-info';
import { SDK } from 'components/record-button/constants';
import Scopes from 'components/scopes';
import TitleBar from 'components/share-page-common/title-bar';
import SalesforceModal from 'components/share-video/salesforce-share/salesforce-modal';
import Button from 'components/ui-components/button';
import CreateHintTooltip from 'components/ui-components/create-hint-tooltip';
import ErrorBoundary from 'components/ui-components/error-boundary';
import Modal from 'components/ui-components/modal';
import VideoFrame from 'components/video-frame';
import PermissionModal from 'components/video-player/permission-modal';
import FillerRemovalModal from 'components/video-player/video/filler-volume-control/filler-removal-modal';
import MoveModalTA from 'components/videos-dashboard-ta/move-modal';

import './styles.less';

const RecordButton = React.lazy(() => import('components/record-button'));
const PersistentRecordButton = React.lazy(() =>
  import('components/record-button/persistent-record-button')
);
// added to the document body of the share page to fade everything to black
const TRIM_MODE_CLASS = 'trim-mode-enabled';

// analytics event for notification dialog upselling
const SHARE_VIDEO_PAGE_TITLE = 'Share Video';

// status bar class (bg dark color) for notification dialog upselling
const HAS_STATUS_BAR_CLASS = 'has-status-bar';

const InactiveVideoContactOwnerModal = props => {
  const { show, name, pingOwner, ownerPinged, goToLoom } = props;

  const notPingedContent = (
    <>
      <div className="share-video-inactive-video-contact-modal-title">
        This video is currently inactive.
      </div>
      <div className="share-video-inactive-video-contact-modal-content">
        {`We'll let ${
          name || 'the owner'
        } know you'd like to watch their video.`}
      </div>
      <div className="share-video-inactive-video-contact-modal-action">
        <Button
          onClicked={pingOwner}
          buttonType="rp-primary-2"
          value="Yes! Let them know."
        />
      </div>
    </>
  );

  const pingedContent = (
    <>
      <div className="share-video-inactive-video-contact-modal-title">
        Thanks!
      </div>
      <div className="share-video-inactive-video-contact-modal-content">
        Your request is on its way! 🚀
      </div>
      <div className="share-video-inactive-video-contact-modal-action">
        <Button
          capitalize={false}
          onClicked={goToLoom}
          buttonType="rp-primary-2"
          value="Go to loom.com"
        />
      </div>
    </>
  );

  return (
    <div className="share-video-inactive-video-contact-modal">
      <Modal show={show} dark={true} showClose={false}>
        {ownerPinged ? pingedContent : notPingedContent}
      </Modal>
    </div>
  );
};

const PaywallModals = ({
  showRecordingTimerPaywall,
  user,
  hasSeenRecordingLimitModal,
  fromRecorderParam,
  recordingLimitParam,
}) => {
  const workspaceVideoDurationLimit = useWorkspaceLimit(VIDEO_DURATION);
  const memberVideoDurationLimit = useRoleLimit(VIDEO_DURATION);
  const videoDurationLimit =
    workspaceVideoDurationLimit || memberVideoDurationLimit;

  // If we're coming from a location that's not the recorder (e.g. library, don't show paywalls)
  if (!fromRecorderParam) {
    return null;
  }

  // We show the content limit modal when the content limit was reached but the user was not
  // cut off because of the recording timer limit
  const showContentModal = !recordingLimitParam;

  // If we know the workspace has a recording limit and if the user has reached that limit,
  // show them the recording timer paywall modal (or toast)
  return (
    <>
      {showContentModal && <ContentLimitPaywallModal />}
      {showRecordingTimerPaywall &&
        videoDurationLimit &&
        recordingLimitParam && (
          <RecordingTimerPaywallModal
            user={user}
            renderToast={hasSeenRecordingLimitModal}
            videoDurationLimit={videoDurationLimit}
          />
        )}
    </>
  );
};

const LoomBranding = () => {
  const [isSdkSupported, setIsSdkSupported] = React.useState(false);
  const isMobile = useMatchMobileOnly();

  React.useEffect(() => {
    (async () => {
      const { supported } = await importedIsSdkSupported();

      setIsSdkSupported(supported);
    })();
  }, []);

  const experimentIsAllowed = !isMobile && isSdkSupported;

  const showPersistentRecordButton = useFeatureFlagValue(
    EXP_PERSISTENT_RECORD_BUTTON_SIGNED_OUT
  );

  return (
    <>
      {getLoomBrandVisibility() &&
        getCustomBrandLogo() &&
        showPersistentRecordButton === 'variant' && (
          <>
            {showPersistentRecordButton && experimentIsAllowed ? (
              <Container position="fixed" bottom={2.5}>
                <Suspense fallback={null}>
                  <RecordButton priorityList={[SDK]}>
                    <PersistentRecordButton isCollapsed={false} />
                  </RecordButton>
                </Suspense>
              </Container>
            ) : (
              <div className="share-video-loom-badge-section">
                <LoomBadge href="https://www.loom.com" title="Loom homepage" />
              </div>
            )}
          </>
        )}
    </>
  );
};

class ShareVideo extends Component {
  state = {
    showClaimModal: false,
    show_create_recording_tooltip: false,
    show_ext_install_bubb: false,
    startTimeParam: getParam('t'),
    video_id: window.location.pathname.replace('/share/', ''),
    ownerPinged: false,
    mobileAppCardIsVisible: true,
  };

  render() {
    const {
      video_id: videoId,
      show_create_recording_tooltip: showCreateRecordingTooltip,
      startTimeParam,
    } = this.state;

    const {
      activeVideoTranscriptId,
      anonCreatorMode,
      breadcrumbs,
      ctaEnabled,
      currentUserIsOwner,
      downloadUrl,
      errorBarShown,
      fetchingVideo,
      focusTitle,
      fromRecorderParam,
      hasSeenRecordingLimitModal,
      hasAuthenticatedAccessScope,
      hasVideoToolsAccessScope,
      iframeLoaded,
      inTrimMode,
      isLoggedIn,
      isTeamAccount,
      isVideoShareModalOpen,
      needsPermission,
      ownerFullName,
      ownerAvatar,
      playerReady,
      recordingLimitParam,
      selectedWorkspace,
      sfdcModalShow,
      showCtaModal,
      showMoveModal,
      showRecordingTimerPaywall,
      showRemoveModal,
      showThumbnailCropper,
      showUploadAttachmentProgressModal,
      showVideoSettings,
      theaterMode,
      transcriptStatus,
      transcriptVisible,
      updateVideoNameCreator,
      showControlBar,
      user,
      userCanAccessTranscript,
      userCanEdit,
      userCompletedOnboarding,
      video,
      videoIsSharedWithUser,
      videoIsTeamShared,
      videoPlayerControlsActive,
      videoPlayerHasStarted,
      viewerInsightsActive,
    } = this.props;
    const { video_properties: videoProperties, parentVideoProperties } = video;
    const { isVideoReply } = videoProperties;

    const companyFeatureData = video.company_feature_data || null;

    const showRightPanel =
      !inTrimMode &&
      (transcriptVisible ||
        viewerInsightsActive ||
        showCtaModal ||
        showThumbnailCropper ||
        showVideoSettings);

    const titleBar = (
      <TitleBar
        userCanEdit={
          (userCanEdit && hasVideoToolsAccessScope) || anonCreatorMode
        }
        shouldFocusTitle={userCanEdit && focusTitle}
        video={video}
        onTitleUpdate={updateVideoNameCreator}
      />
    );

    const EditVideoButtons =
      userCanEdit &&
      !inTrimMode &&
      (props => (
        <EditVideoButtonsComponent
          isHidden={videoPlayerHasStarted && !videoPlayerControlsActive}
          onEnterTrimMode={this.handleEnterTrimMode}
          {...props}
        />
      ));

    const AnonEditVideoButtons = props => {
      if (!this.props.anonCreatorMode) {
        return null;
      }

      return (
        <AnonEditVideoButtonsComponent
          isHidden={videoPlayerHasStarted && !videoPlayerControlsActive}
          {...props}
        />
      );
    };

    const ViewerVideoButtons =
      !userCanEdit &&
      (props => (
        <ViewerVideoButtonsComponent
          isHidden={videoPlayerHasStarted && !videoPlayerControlsActive}
          {...props}
        />
      ));

    const shouldDisableTranscript =
      !activeVideoTranscriptId ||
      transcriptStatus === FAILED ||
      !TRANSCRIPTION_STATUSES.includes(transcriptStatus);

    const transcriptIconButton = (
      <TranscriptIconButton
        shouldDisableTranscript={shouldDisableTranscript}
        handleToggleTranscriptCreator={this.props.handleToggleTranscriptCreator}
        currentUserIsOwner={currentUserIsOwner}
      />
    );

    const transcriptButton =
      activeVideoTranscriptId &&
      userCanAccessTranscript &&
      !inTrimMode &&
      transcriptIconButton;

    const useAnonymousNavigation =
      !isLoggedIn ||
      !hasAuthenticatedAccessScope ||
      !isTeamAccount ||
      !userCompletedOnboarding;

    const showFillerRemovalModal =
      currentUserIsOwner && activeVideoTranscriptId && fromRecorderParam;

    return (
      <>
        {video?.video_properties?.recording_version === V4 ? (
          <OldTrimExitWarningModal />
        ) : (
          <>
            <FeatureFlaggedComponent
              flag={ROLLOUT_WEAVE}
              activationValues={inactiveDefaultVariations}
            >
              <OldTrimExitWarningModal />
            </FeatureFlaggedComponent>
            <FeatureFlaggedComponent
              flag={ROLLOUT_WEAVE}
              activationValues={VARIANT}
            >
              <TrimExitWarningModal />
            </FeatureFlaggedComponent>
          </>
        )}
        {inTrimMode && (
          <NewWaveformWrapper>
            <div className="sharePageOverlay"></div>
          </NewWaveformWrapper>
        )}

        <div className={classNames({ 'is-blurred': isVideoShareModalOpen })}>
          <Layout
            companyFeatureData={companyFeatureData}
            useAnonymousNavigation={useAnonymousNavigation}
            mainContentHasFullWidth
            hasCompactBreadcrumb
          >
            <ErrorBoundary>
              {!isLoggedIn && (
                <FeatureFlaggedComponent
                  flag={EXP_GOOGLE_ONE_TAP_SHARE_PAGE}
                  activationValues={VARIANT}
                  extraProperties={{ isMobile: device.isMobile }}
                >
                  <GoogleOneTap />
                </FeatureFlaggedComponent>
              )}
              {isLoggedIn && (
                <Scopes name={SUGGESTED_WORKSPACE_BANNER}>
                  <JoinTeamBanner user={user} video={video} />
                </Scopes>
              )}

              <div
                className={classNames('share-video-container', {
                  'current-user-is-owner': currentUserIsOwner,
                  'error-bar-shown': errorBarShown,
                  'theater-mode': theaterMode,
                })}
              >
                <div
                  className={classNames('theater-player-container', {
                    'theater-mode': theaterMode,
                    'use-emojis': showControlBar,
                  })}
                />
                <div className={classNames('panels-container')}>
                  <div
                    className={classNames('left-panel', 'new-engagement-bar', {
                      'use-emojis': showControlBar,
                    })}
                  >
                    <Banners video={video} />
                    <OverlayWrapper>
                      <VideoFrame
                        EditVideoButtons={
                          isLoggedIn ? EditVideoButtons : AnonEditVideoButtons
                        }
                        ViewerVideoButtons={ViewerVideoButtons}
                        startTime={startTimeParam}
                        videoId={videoId}
                      >
                        {showCtaModal && <CtaModal />}
                        {((!device.isMobile && showControlBar) ||
                          inTrimMode) && (
                          <>
                            {inTrimMode && (
                              <OldWaveformWrapper>
                                <ShareVideoControlBar
                                  duration={video.video_properties.duration}
                                  hasGmailAccount={user.has_gmail_account}
                                  isLoggedIn={isLoggedIn}
                                  isProtected={video.is_protected}
                                  onLeaveTrimMode={this.handleLeaveTrimMode}
                                  playerReady={playerReady}
                                  video={video}
                                />
                              </OldWaveformWrapper>
                            )}
                            {!inTrimMode && !showCtaModal && <EngagementBar />}
                          </>
                        )}
                        {showThumbnailCropper && (
                          <ThumbnailCropper videoId={video.id} />
                        )}
                      </VideoFrame>
                    </OverlayWrapper>
                    <OverlayWrapper>
                      {inTrimMode && (
                        <OldWaveformWrapper>
                          <TrimFooter
                            onRevertClicked={this.handleLeaveTrimMode}
                            video={video}
                          />
                        </OldWaveformWrapper>
                      )}
                    </OverlayWrapper>
                    <OverlayWrapper>
                      {inTrimMode && (
                        <NewWaveformWrapper>
                          {video?.video_properties?.recording_version === V4 ? (
                            <OldEditTools />
                          ) : (
                            <>
                              <FeatureFlaggedComponent
                                flag={ROLLOUT_WEAVE}
                                activationValues={inactiveDefaultVariations}
                              >
                                <OldEditTools />
                              </FeatureFlaggedComponent>
                              <FeatureFlaggedComponent
                                flag={ROLLOUT_WEAVE}
                                activationValues={VARIANT}
                              >
                                <EditTools />
                              </FeatureFlaggedComponent>
                            </>
                          )}
                        </NewWaveformWrapper>
                      )}
                    </OverlayWrapper>
                    {!inTrimMode && (
                      <div className="video-metadata-slideable">
                        {transcriptVisible && !inTrimMode && (
                          <div
                            className={
                              theaterMode
                                ? 'share-page-card-below-panel-theater'
                                : 'share-page-card-below-panel'
                            }
                          >
                            <Transcript height={BOTTOM_CARD_HEIGHT} />
                          </div>
                        )}
                        <div className="below-video">
                          <MediaQuery
                            query={`(max-width: ${LARGE_TABLET_MAX_WIDTH}px)`}
                          >
                            <DestinationOnly>
                              <DestinationBreadcrumb
                                breadcrumbs={breadcrumbs}
                              />
                            </DestinationOnly>
                            <Spacer bottom="small" />
                            <div className="share-video-title-tools flex">
                              {titleBar}
                              <Scopes name={WATCH_LATER}>
                                <WatchLaterButton />
                              </Scopes>
                              <Spacer right="small" />
                              <OverflowMenu
                                video={video}
                                isLoggedIn={isLoggedIn}
                              />
                            </div>
                          </MediaQuery>
                          <MediaQuery
                            query={`(min-width: ${SMALL_DESKTOP_MIN_WIDTH}px)`}
                          >
                            <DestinationOnly>
                              <DestinationBreadcrumb
                                breadcrumbs={breadcrumbs}
                              />
                            </DestinationOnly>
                            <Spacer bottom="small" />
                            <div className="share-video-title-tools">
                              {titleBar}
                              <MediaQuery
                                query={`(max-width: ${SMALL_DESKTOP_MIN_WIDTH}px)`}
                              >
                                {transcriptButton}
                              </MediaQuery>
                              <Scopes name={WATCH_LATER}>
                                <WatchLaterButton />
                              </Scopes>
                            </div>
                          </MediaQuery>
                          <div id="intercom-destination-tags">
                            <OwnerInfo
                              currentUserIsOwner={currentUserIsOwner}
                              customLogoUrl={getCustomBrandLogo()}
                              date={video.createdAt}
                              name={ownerFullName}
                              user={user}
                              userAvatarSrc={
                                ownerAvatar &&
                                getCloudfrontURI(ownerAvatar.thumb)
                              }
                              video={video}
                            />
                            <DestinationOnly>
                              <TagsTypeahead
                                video={video}
                                canEdit={
                                  String(video.organization_id) ===
                                  selectedWorkspace?.id
                                }
                              />
                            </DestinationOnly>
                          </div>
                          {!inTrimMode &&
                            (video.description || userCanEdit) && (
                              <VideoDescription
                                userCanEditVideo={userCanEdit}
                              />
                            )}
                          <MediaQuery
                            query={`(min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${SMALL_TABLET_MAX_WIDTH}px)`}
                          >
                            {ctaEnabled && (
                              <div className="mt:large">
                                <CustomCtaButton />
                              </div>
                            )}
                          </MediaQuery>
                        </div>
                        {isVideoReply && (
                          <VideoReplyParentIndicator
                            parentProperties={parentVideoProperties}
                          />
                        )}
                        {userCanEdit && (
                          <div className="tablet-actions">
                            <Scopes names={VIDEO_EDIT_OPTIONS_ACCESS}>
                              <EditorWidget
                                onEnterTrimMode={this.handleEnterTrimMode}
                                video={video}
                              />
                            </Scopes>
                          </div>
                        )}
                        {!userCanEdit && (
                          <FeatureFlaggedComponent
                            flag={ROLLOUT_FILE_ATTACHMENTS}
                            activationValues={[true]}
                          >
                            <AttachmentsBar />
                          </FeatureFlaggedComponent>
                        )}
                        {(userCanEdit || video.comments_enabled) && (
                          <Comments iframeLoaded={iframeLoaded} />
                        )}
                      </div>
                    )}
                    <ConfirmationModal />
                    {isTeamAccount && showMoveModal ? (
                      <MoveModalTA isSharePage={true} />
                    ) : (
                      <MoveModal />
                    )}
                  </div>
                  {showRightPanel && (
                    <RightPanel
                      onEnterTrimMode={this.handleEnterTrimMode}
                      theaterMode={theaterMode}
                      userCanEdit={userCanEdit}
                      selectedWorkspace={selectedWorkspace}
                      user={user}
                      transcriptVisible={transcriptVisible}
                      onTranscriptExit={
                        this.props.handleToggleTranscriptCreator
                      }
                    />
                  )}
                </div>

                <VideoRemoveModal
                  isOpen={showRemoveModal}
                  videoId={videoId}
                  onCloseModal={this.handleLeaveRemoveModal}
                  videoIsTeamShared={videoIsTeamShared}
                  videoIsSharedWithUser={videoIsSharedWithUser}
                />
              </div>
              {showCreateRecordingTooltip && (
                <CreateHintTooltip
                  onClose={() => {
                    this.setState({ show_create_recording_tooltip: false });
                  }}
                />
              )}
              {showFillerRemovalModal && (
                <MediaQuery query={`(min-width: ${SMALL_DESKTOP_MIN_WIDTH}px)`}>
                  <FeatureFlaggedComponent
                    flag={STORE_FILLER_WORD_RANGES}
                    activationValues={[true]}
                  >
                    <FillerRemovalModal />
                  </FeatureFlaggedComponent>
                </MediaQuery>
              )}
              <PaywallModals
                showRecordingTimerPaywall={showRecordingTimerPaywall}
                hasSeenRecordingLimitModal={hasSeenRecordingLimitModal}
                fromRecorderParam={fromRecorderParam}
                recordingLimitParam={recordingLimitParam}
                user={user}
              />
              <ProcessErrorModal />
              <InactiveVideoContactOwnerModal
                goToLoom={this.goToLoom}
                pingOwner={this.pingOwner}
                ownerPinged={this.state.ownerPinged}
                name={video.owner_name}
                show={!currentUserIsOwner && !video.active_status}
              />
              {!fetchingVideo && needsPermission && <PermissionModal />}
              {showUploadAttachmentProgressModal && (
                <AttachmentUploadProgressModal />
              )}
              <div id="gmail-integration-share-page-placeholder" />
            </ErrorBoundary>
            <LoomBranding />
            {getLoomBrandVisibility() &&
              device.isMobile &&
              this.state.mobileAppCardIsVisible && (
                <FeatureFlaggedComponent
                  flag={SHOW_MOBILE_APP_CARD}
                  activationValues={[true]}
                >
                  <MobileAppCard onCloseClick={this.handleMobileAppCardClose} />
                </FeatureFlaggedComponent>
              )}

            <SharePageHeaderContent
              user={user}
              video={video}
              isLoggedIn={isLoggedIn}
              downloadUrl={downloadUrl}
              currentUserIsOwner={currentUserIsOwner}
              videoIsTeamShared={videoIsTeamShared}
            />

            <FeatureFlaggedComponent
              flag={ROLLOUT_INTEGRATIONS_LISTING}
              activationValues={[true]}
            >
              <SalesforceModal showModal={sfdcModalShow} />
            </FeatureFlaggedComponent>
          </Layout>
        </div>
      </>
    );
  }

  async componentDidMount() {
    // replyVideoId param will trigger the record reply signup modal
    // if the user hasn't finish onboarding
    if (hasParam('replyVideoId')) {
      const videoCurrentTime = getParam('videoCurrentTime');

      if (videoCurrentTime) {
        this.props.requestVideoPlayerCurrentTime(videoCurrentTime);
      }

      if (!this.props.welcomeComplete) {
        this.props.openModal(SHARE_RECORD_REPLY_SIGNUP_MODAL);
      }
    }

    if (hasParam('resume-signup')) {
      this.props.openModal(ANON_CREATOR_SIGNUP_MODAL);
    }

    window.addEventListener('message', this.handleShareVideoEvents);

    const {
      currentUserIsOwner,
      fetchShareVideoDownloadUrlCreator,
      shouldOpenInsights,
      fromRecorderParam,
      showConfirmationModal,
      subscribeGifReady,
      theaterMode,
      toggleViewerInsightsUI,
      updateVideoCtaShow,
      updateVideoIframeVisibility,
      user = {},
      video = {},
    } = this.props;

    if (!this.props.isLoggedIn) {
      this.props.fetchAnonCreatorMode(video.id);
    }

    if (theaterMode) {
      this.attachPlayerToTheaterElement();
    }

    if (video.complete) {
      updateVideoIframeVisibility();
      fetchShareVideoDownloadUrlCreator();
    }

    if (
      currentUserIsOwner &&
      fromRecorderParam &&
      video.video_properties.slackRecordingSession
    ) {
      // TODO (@diaswrd): Implement fallback mechanism to open the web version of Slack
      // if the desktop client launch fails
      window.location.replace('slack://');
    }

    subscribeGifReady(video.id);

    if (user.capabilities[END_OF_VIDEO_CTA] === true) {
      updateVideoCtaShow(true);
    }

    const installed = await new Promise(resolve => {
      extension.isInstalled(resolve);
    });

    if (
      !installed &&
      (extension.canRunExtension || (!device.isMobile && !device.isChrome))
    ) {
      this.setState({
        show_ext_install_bubb: true,
      });
    }

    this.setState({
      startTimeParam: getParam('t'),
    });

    if (shouldOpenInsights) {
      toggleViewerInsightsUI();
    }

    if (fromRecorderParam) {
      const wasCopied = clipboard.copyText(
        `${LOOM_URI}/share/${this.props.video.id}`
      );

      if (wasCopied) {
        showConfirmationModal(this.getCopyLinkConfirmation(), INFO, 6000);
      }
    }

    const override = getParam('ftuxOverride');

    if (override === SHOW_FIRST_FILLER_REMOVAL_EXPERIENCE) {
      this.props.activateTriggerCreator(override);
    }

    getFlagValueForUser(EXP_SWIMLANES_AA);
    getFlagValueForUser(EXP_ANON_SWIMLANES_AA);
  }

  componentDidUpdate(prevProps) {
    const { inTrimMode, theaterMode } = this.props;

    if (this.props.anonCreatorMode && !prevProps.anonCreatorMode) {
      this.props.openModal(ANON_CREATOR_CLAIM_MODAL);
    }

    // This is the quickest and smoothest way to move a video to a different element
    // and not cause any jiterryness
    if (!prevProps.theaterMode && theaterMode) {
      this.attachPlayerToTheaterElement();
    }

    if (prevProps.theaterMode && !theaterMode) {
      this.removePlayerFromTheaterElement();
    }

    if (inTrimMode != prevProps.inTrimMode) {
      const rootElement = document.documentElement;

      rootElement.className = rootElement.className.replace(
        TRIM_MODE_CLASS,
        ''
      );

      if (inTrimMode) {
        rootElement.className += ` ${TRIM_MODE_CLASS}`;
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleShareVideoEvents);
  }

  attachPlayerToTheaterElement = () => {
    let timer;
    // the theater container might not be available
    // or it might temporarily go away
    // make sure we catch this and retry
    const waitForDomReady = () => {
      const theaterPlayerContainer = document.querySelector(
        '.theater-player-container'
      );

      if (!theaterPlayerContainer) {
        timer = setTimeout(waitForDomReady, 10);

        return;
      }

      clearTimeout(timer);
      theaterPlayerContainer.appendChild(
        document.querySelector('.embed-video-frame-wrapper')
      );

      // TODO: Convert to react functional component and use react hook
      // to trigger getResponsiveVideoWrapperDimensions
      // https://useloom.atlassian.net/projects/LOOM/issues/LOOM-65
      // @paulius005
      this.forceUpdate();
    };

    waitForDomReady();
  };

  removePlayerFromTheaterElement = () => {
    const leftPanel = document.querySelector('.left-panel');

    leftPanel.insertBefore(
      document.querySelector('.embed-video-frame-wrapper'),
      leftPanel.firstChild
    );

    // TODO: Convert to react functional component and use react hook
    // to trigger getResponsiveVideoWrapperDimensions
    // https://useloom.atlassian.net/projects/LOOM/issues/LOOM-65
    // @paulius005
    this.forceUpdate();
  };

  pingOwner = () => {
    this.props.sendInactiveVideoOwnerPing();

    this.setState({ ownerPinged: true });
  };

  goToLoom = () => (window.location.pathname = ROOT_PAGE);

  handleLeaveRemoveModal = () => {
    this.props.updateShareVideoShowRemoveModal(false);
  };

  handleEnterTrimMode = () => {
    const {
      id: videoId,
      processing_information: { trim_ranges: trimRanges = [] },
    } = this.props.video;

    this.props.enterTrimModeCreator(trimRanges);

    this.props.updateShareVideoInTrimMode(true);

    analytics.track(ENTERED_TRIM_MODE, {
      id: videoId,
      has_been_trimmed: trimRanges.length > 0,
      event_type: 'click',
    });
  };

  handleLeaveTrimMode = () => {
    this.props.updateShareVideoInTrimMode(false);
  };

  handleNotificationDialogPromptClose = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [REQUEST_PUSH_PERMISSIONS]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(PUSH_NOTIFICATION_PROMPT_DISMISSED);

      this.props.completeTriggerCreator(REQUEST_PUSH_PERMISSIONS);
    }
  };

  handleNotificationStatusBarAction = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [NEW_ONBOARDING_EXISTING_USER]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(NEW_ONBOARDING_EXISTING_USER_COMPLETE, {
        go_to_use_cases: true,
        from_page: SHARE_VIDEO_PAGE_TITLE,
      });

      this.props.completeTriggerCreator(NEW_ONBOARDING_EXISTING_USER);
      jqueryExt.oneTransitionEnd($('.status-bar'), () => {
        $('#container').removeClass(HAS_STATUS_BAR_CLASS);
      });

      goToNewTab(`${LOOM_URI}${WELCOME}`);
    }
  };

  handleNotificationStatusBarClose = () => {
    const { isLoggedInChecked, isLoggedIn, triggers } = this.props;

    if (!isLoggedInChecked || !isLoggedIn) {
      return;
    }

    const { [NEW_ONBOARDING_EXISTING_USER]: trigger } = triggers;

    if (trigger.complete === false && trigger.show === true) {
      analytics.track(NEW_ONBOARDING_EXISTING_USER_COMPLETE, {
        go_to_use_cases: false,
        from_page: SHARE_VIDEO_PAGE_TITLE,
      });

      this.props.completeTriggerCreator(NEW_ONBOARDING_EXISTING_USER);
      jqueryExt.oneTransitionEnd($('.status-bar'), () => {
        $('#container').removeClass(HAS_STATUS_BAR_CLASS);
      });
    }
  };

  handleShareVideoEvents = e => {
    const origin =
      e.origin || (e.originalEvent && e.originalEvent.origin) || '';
    const data = e.data || (e.originalEvent && e.originalEvent.data) || {};

    if (origin.indexOf(LOOM_URI) < 0) {
      return;
    }

    switch (data.type) {
      case EMBED_DIMENSIONS_UPDATE:
        this.props.updateShareVideo({
          ...this.props.video,
          video_properties: {
            ...this.props.video.video_properties,
            height: data.height,
            width: data.width,
          },
        });
        break;
      case EMBED_VIDEO_CORRECT_PASS:
        this.props.updateShareVideoPassword(data.password);
        this.props.fetchShareVideoDownloadUrlCreator();
        break;
      case EMBED_VIDEO_DURATION:
        this.props.updateShareVideo({
          ...this.props.video,
          video_properties: {
            ...this.props.video.video_properties,
            duration: data.duration,
          },
        });
        break;
      case EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED:
        this.props.updateShareVideo({
          ...this.props.video,
          processing_information: data.processing_information,
        });
        this.props.fetchShareVideoDownloadUrlCreator();
        break;
      case EXTENSION_CLICKED:
        this.setState({ show_create_recording_tooltip: false });
        break;
      default:
    }
  };

  handleMobileAppCardClose = () => {
    this.setState({ mobileAppCardIsVisible: false });
  };

  getCopyLinkConfirmation = () => {
    return 'Link copied to clipboard!';
  };
}

const mapStateToProps = state => {
  const {
    current_user_is_owner: currentUserIsOwner,
    download_url: downloadUrl,
    iframe_loaded: iframeLoaded,
    player_ready: playerReady,
    show_remove_modal: showRemoveModal,
    cta_enabled: ctaEnabled,
    video,
    video_folders: breadcrumbs,
    video_is_team_shared: videoIsTeamShared,
    sfdcModalShow,
    transcript_details: { transcription_status: transcriptStatus },
    anonCreatorMode,
  } = state.share_video;

  const { selectedWorkspace } = state.workspace;

  const { download_enabled: downloadEnabled } = video;

  const {
    is_logged_in: isLoggedIn,
    is_logged_in_checked: isLoggedInChecked,
    current,
  } = state.user;

  const { showUploadAttachmentProgressModal } = state.attachments;

  const { has_reached_recording_limit: hasSeenRecordingLimitModal } =
    state.checklist;

  const { triggers } = state.triggers;

  const { in_trim_mode: inTrimMode } = state.trimming;

  const { showing: errorBarShown } = state.error_bar;

  const { cta_flow, thumbnail_flow, video_settings_flow } = state.editor;

  const {
    controlsActive: videoPlayerControlsActive,
    has_started: videoPlayerHasStarted,
    is_fetching: fetchingVideo,
    viewer_needs_permission: needsPermission,
    theater_mode: theaterMode,
    transcriptVisible,
    userCanAccessTranscript,
  } = state.video_player;

  const ownerFullName = state.video_player.video.owner_full_name;
  const ownerAvatar = state.video_player.video.owner_avatar;

  const { complete: userCompletedOnboarding } = state.welcome;

  const { showMoveModal } = state.moveModal;

  const videoIsSharedWithUser =
    Object.keys(video.collaboratePermissions).length > 0;
  const isTeamAccount = TEAM_ACCOUNT_TYPES.includes(current.account_type);

  const showRecordingTimerPaywall = hasSomeScopes(state, [
    RECORDING_TIMER_PAYWALL,
    RECORDING_TIMER_PAYWALL_LITE,
  ]);

  const { full_screen: fullScreen } = state.video_player;

  const { isOpen: isVideoShareModalOpen } = state.firstVideoShareModal;

  const { complete: welcomeComplete } = state.welcome;

  return {
    activeVideoTranscriptId: video.active_video_transcript_id,
    anonCreatorMode,
    breadcrumbs,
    ctaEnabled,
    currentUserIsOwner,
    downloadUrl: currentUserIsOwner || downloadEnabled ? downloadUrl : null,
    errorBarShown,
    fetchingVideo,
    fullScreen,
    hasSeenRecordingLimitModal,
    hasAuthenticatedAccessScope: hasScope(state, AUTHENTICATED_USER_ACCESS),
    hasVideoToolsAccessScope: hasScope(state, VIDEO_TOOLS_ACCESS),
    iframeLoaded,
    inTrimMode,
    isLoggedIn,
    isLoggedInChecked,
    isTeamAccount,
    isVideoShareModalOpen,
    needsPermission,
    ownerFullName,
    ownerAvatar,
    playerReady,
    selectedWorkspace,
    sfdcModalShow,
    showCtaModal: cta_flow,
    showMoveModal,
    showRecordingTimerPaywall,
    showRemoveModal,
    showThumbnailCropper: thumbnail_flow,
    showUploadAttachmentProgressModal,
    showVideoSettings: video_settings_flow,
    theaterMode,
    transcriptStatus,
    transcriptVisible,
    triggers,
    showControlBar: selectDrawSharepageControlBar(state),
    user: current,
    userCanAccessTranscript,
    userCanEdit: video.currentUserCanEdit,
    userCompletedOnboarding,
    video,
    videoIsSharedWithUser,
    videoIsTeamShared,
    videoPlayerControlsActive,
    videoPlayerHasStarted,
    viewerInsightsActive: viewerInsightsActive(state),
    welcomeComplete,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    completeTriggerCreator: trigger =>
      dispatch(completeTriggerCreator(trigger)),
    enterTrimModeCreator: trimRanges =>
      dispatch(enterTrimModeCreator(trimRanges)),
    fetchShareVideoDownloadUrlCreator: () =>
      dispatch(fetchShareVideoDownloadUrlCreator()),
    getFeatureFlag: featureFlag => dispatch(getFeatureFlagCreator(featureFlag)),
    handleToggleTranscriptCreator: () =>
      dispatch(handleToggleTranscriptCreator()),
    openModal: modal => dispatch(openModal(modal)),
    postVerifyEmail: () => dispatch(postVerifyEmail()),
    requestVideoPlayerCurrentTime: currentTime =>
      dispatch(requestVideoPlayerCurrentTime(currentTime)),
    sendInactiveVideoOwnerPing: () => dispatch(sendInactiveVideoOwnerPing()),
    showConfirmationModal: (message, severity, timerTimeout) =>
      dispatch(showConfirmationModal(message, severity, timerTimeout)),
    showErrorBar: (severity, message) =>
      dispatch(showErrorBar(severity, message)),
    showStatusBar: statusBarParams => dispatch(showStatusBar(statusBarParams)),
    subscribeGifReady: id => dispatch(subscribeToGif(id)),
    toggleViewerInsightsUI: () => dispatch(toggleViewerInsightsUI()),
    updateLoginOrSignUp: logIn => dispatch(updateLoginOrSignUp(logIn)),
    updateNotificationSettings: notificationSettings =>
      dispatch(updateNotificationSettings(notificationSettings)),
    updateShareVideo: video => dispatch(updateShareVideo(video)),
    updateShareVideoInTrimMode: inTrimMode =>
      dispatch(updateShareVideoInTrimMode(inTrimMode)),
    updateShareVideoPassword: password =>
      dispatch(updateShareVideoPassword(password)),
    updateShareVideoShowRemoveModal: show =>
      dispatch(updateShareVideoShowRemoveModal(show)),
    updateVideoCtaShow: show => dispatch(updateVideoCtaShow(show)),
    updateVideoIframeVisibility: isVisible =>
      dispatch(updateVideoIframeVisibility(isVisible)),
    updateVideoNameCreator: name => dispatch(updateVideoNameCreator(name)),
    activateTriggerCreator: name => dispatch(activateTriggerCreator(name)),
    fetchAnonCreatorMode: videoId => dispatch(fetchAnonCreatorMode(videoId)),
  };
};

const ComponentInstance = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareVideo);

export default ComponentInstance;
